
import Task from "./Task";
import { Routes, Route, Navigate } from "react-router-dom";
import TaskTab from "./TaskTab";
import TaskGroup from "./TaskGroup.jsx";
import TaskGroupAdd from "./TaskGroupAdd";
import TaskResponsible from "./TaskResponsible.jsx";
import TaskResponsibleAdd from "./TaskResponsibleAdd.jsx";
import TaskGroupDetail from "./TaskGroupDetail.jsx";


const TaskRoute = () => {

    return (

        <Routes>
            <Route path="/" element={<TaskTab />} >
                <Route index element={<Navigate to="group" replace />} />
                <Route path="group" element={<TaskGroup />} />
                <Route path="responsible" element={<TaskResponsible />} />
            </Route>
            <Route path="group/:seq" element={<TaskGroupDetail />} />
            <Route path="groupAdd" element={<TaskGroupAdd />} />
            <Route path="responsibleAdd" element={<TaskResponsibleAdd />} />
        </Routes>


    );
}

export default TaskRoute;